import OSS from 'ali-oss'
import { getOssSts } from '@/api/common'

export async function OssClient(bucket) {
  const ossConfig = {
    region: 'oss-cn-shenzhen',
    accessKeyId: '',
    accessKeySecret: '',
    stsToken: '',
    bucket: bucket || 'wondfo-soft'
  }
  let client = null
  await getOssSts().then(response => {
    // console.log(response)
    ossConfig.accessKeyId = response.data.accessKeyId
    ossConfig.accessKeySecret = response.data.accessKeySecret
    ossConfig.stsToken = response.data.securityToken
    // console.log(ossConfig)
    client = new OSS(ossConfig)
  })
  return client
}
